'use client'; // Error boundaries must be Client Components

import { getCookieValue } from '@/utils/cookies/client';
import { SvgLoader } from './elements/svg/loader';
import './global-error.scss';
import { Inter, Roboto_Condensed } from 'next/font/google';
import { COOKIES } from '@/utils/cookies';

const interRegular = Inter({
    subsets: ['latin'],
    display: 'swap',
    weight: '400',
    variable: '--font-inter-regular'
});

const interBold = Inter({
    subsets: ['latin'],
    display: 'swap',
    weight: '700',
    variable: '--font-inter-bold'
});

const robotoCondensedRegular = Roboto_Condensed({
    subsets: ['latin'],
    display: 'swap',
    weight: '400',
    variable: '--font-roboto-condensed-regular'
});

const GlobalError: React.FC<{
    error: Error & { digest?: string };
}> = ({ error }) => {
    const fontVariables = `${interRegular.variable} ${interBold.variable} ${robotoCondensedRegular.variable}`;

    const getSupportLink = () => {
        switch (process.env.BRAND) {
            case 'fanduel':
                const region = getCookieValue(COOKIES.REGION) || 'mi';

                if (process.env.PRODUCT === 'poker') {
                    return `https://account.${region.toLowerCase()}.poker.fanduel.com/support`;
                }

                return `https://account.${region.toLowerCase()}.casino.fanduel.com/support`;
            case 'mohegansun':
                return `https://account.ct.mohegansuncasino.com/support`;
            default:
                return `https://account.mi.casino.fanduel.com/support`;
        }
    };

    return (
        <html lang="en" className={fontVariables}>
            <body className="error-page" data-testid="global-error">
                <div className="error-overlay"></div>
                <main className="error-modal">
                    <div className="error-icon">
                        <SvgLoader aria-hidden="true" className="error-icon" iconName="system-error" />
                    </div>

                    <h1>Something went wrong</h1>
                    <p>We had a temporary issue loading this. Refresh this page and you&apos;re back in action.</p>
                    <p>
                        If you&apos;re still having trouble, <a href={getSupportLink()}>support</a> can help.
                    </p>
                    <p>Error code: {error.digest ?? 'Internal Server Error'}</p>

                    <button onClick={() => window.location.reload()}>Refresh the page</button>
                </main>
            </body>
        </html>
    );
};

export default GlobalError;
